import React from 'react'

const C = { up: '#639922', down: '#BA7517', neutral: 'var(--text-secondary)' }

export function KpiCard({ label, value, delta, deltaLabel, tone = 'neutral' }) {
  const color = C[tone] || C.neutral
  return (
    <div style={styles.card}>
      <div style={styles.label}>{label}</div>
      <div style={styles.value}>{value}</div>
      {(delta !== undefined && delta !== null) && (
        <div style={{ ...styles.delta, color }}>
          {typeof delta === 'number' && (delta > 0 ? '▲ +' : delta < 0 ? '▼ ' : '')}
          {delta}{deltaLabel ? ` ${deltaLabel}` : ''}
        </div>
      )}
    </div>
  )
}

const styles = {
  card: {
    background: 'var(--surface)', border: '1px solid var(--border)',
    borderRadius: 'var(--radius)', padding: 16,
    display: 'flex', flexDirection: 'column', gap: 4,
  },
  label: { fontSize: 12, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: 0.4 },
  value: { fontSize: 28, fontWeight: 600 },
  delta: { fontSize: 12, fontWeight: 500 },
}
